// TODO: tunnel through beta.commerce.coinbase.com
const COMMERCE_API_DEV = 'https://commerce-api-dev.cbhq.net';
const COMMERCE_API_PROD = 'https://api.commerce.coinbase.com';

export function getBaseUrl() {
  if (self.DEVTOOL_STATE?.testnet) {
    return COMMERCE_API_DEV;
  }

  return COMMERCE_API_PROD;
}
